(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ft-site]').forEach((site) => {
      if (site.dataset.ftInitialized === 'true') return;
      site.dataset.ftInitialized = 'true';

      const menuButton = site.querySelector('[data-ft-menu-toggle]');
      const menu = menuButton && site.querySelector(`#${CSS.escape(menuButton.getAttribute('aria-controls'))}`);
      const closeMenu = () => {
        if (!menuButton || !menu) return;
        menuButton.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      };

      if (menuButton && menu) {
        menuButton.addEventListener('click', () => {
          const wasOpen = menuButton.getAttribute('aria-expanded') === 'true';
          menuButton.setAttribute('aria-expanded', String(!wasOpen));
          menu.hidden = wasOpen;
        });
        menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
        site.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
            closeMenu();
            menuButton.focus();
          }
        });
        site.addEventListener('click', (event) => {
          if (!menu.contains(event.target) && !menuButton.contains(event.target)) closeMenu();
        });
      }

      const inquiry = site.querySelector('[data-ft-inquiry]');
      if (!inquiry) return;
      const address = inquiry.dataset.contactEmail;
      const select = inquiry.querySelector('[data-ft-subject]');
      const emailLink = inquiry.querySelector('[data-ft-email-link]');
      if (!select || !emailLink) return;

      const updateEmail = () => {
        const subject = select.value;
        const isKit = subject === 'DIY white figurine and tool kit';
        const body = [
          'Hello Famitiny,',
          '',
          `I am interested in: ${subject}.`,
          '',
          'My idea and the details I would love to include:',
          '',
          'Number of people or pets and preferred size:',
          '',
          ...(isKit ? ['The tools or paint options I would like to discuss:', ''] : []),
          'My delivery country and any special date:',
          '',
          'I will attach my reference photos to this email.',
          '',
          'Thank you!'
        ].join('\n');
        emailLink.href = `mailto:${address}?subject=${encodeURIComponent(`My Famitiny keepsake — ${subject}`)}&body=${encodeURIComponent(body)}`;
      };

      select.addEventListener('change', updateEmail);
      site.querySelectorAll('[data-ft-category]').forEach((link) => {
        link.addEventListener('click', () => {
          const subject = link.dataset.ftCategory;
          if ([...select.options].some((option) => option.value === subject)) {
            select.value = subject;
            updateEmail();
          }
        });
      });
      updateEmail();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
